import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessChats } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { ChatDetailPage } from "./pages/detail/ChatDetailPage";
import { ChatListPage } from "./pages/list/ChatListPage";
import { chatsRoutes } from "./routes";

export const chatsRoute = [
  {
    path: chatsRoutes.list,
    element: (
      <RequireAuth permission={canAccessChats}>
        <ChatFeatureWrapper />
      </RequireAuth>
    ),
  },
  {
    path: chatsRoutes.details,
    element: <ChatDetailPage />,
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];

function ChatFeatureWrapper() {
  return <ChatListPage />;
}
